import { render } from "./subReasonManage.vue?vue&type=template&id=0c55974e&scoped=true"
import script from "./subReasonManage.vue?vue&type=script&lang=js"
export * from "./subReasonManage.vue?vue&type=script&lang=js"

import "./subReasonManage.vue?vue&type=style&index=0&id=0c55974e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c55974e"]])

export default __exports__